import { Accordion, Flex, List, Text } from '@applyboard/crystal-ui';
import { useEventTracker } from '@applyboard/ui-utils';
import { useGetTrackingEventData } from '../../common/hooks/useQueryParams';

const FaqAccordion = () => {
  const { trackEvent } = useEventTracker();
  const { rpId, source } = useGetTrackingEventData();

  const QUESTIONS_AND_ANSWERS = [
    {
      question: 'How much can I make?',
      answer:
        'Each ApplyBoard service your student participates in will result in standard commissions for that service. In addition, when the same student completes multiple services through ApplyBoard, you will make extra money based on the offers above.',
    },
    {
      question: 'How and when do I get paid?',
      answer:
        'Reward payments go to your ApplyBoard wallet when all eligible services for that student have been completed. This is typically around the time that you receive commissions for school enrollments for your student.',
    },
    {
      question: 'Is this an additional bonus, or is it part of my commission?',
      answer: 'ApplyBoard Rewards is an extra bonus paid on top of your standard commission.',
    },
    {
      question: 'How can I check the status of each service for each student?',
      answer:
        'You will receive weekly updates via email so you can check the status of your students and their progression in enrolling in each service.',
    },
    {
      question: 'Is this a permanent program?',
      answer:
        'This edition of ApplyBoard Rewards is limited and will be available to you only until December 31st, 2024. We will honor applications for GICs and Loans that started between October 23rd, 2024 and December 31st, 2024, even if the service completion happens after the end of the program.',
    },
    {
      question: 'Who should I contact if I have questions?',
      answer:
        'If you have any questions, please send them to rewards@applyboard.com. Our team will be in touch to assist you.',
    },
    {
      question: 'What does “completion” mean for each service?',
      answer: (
        <Flex>
          <Text>
            Each of ApplyBoard&apos;s services have their own steps from start to finish, and
            therefore reaching completion is different per service:
            <List>
              <List.Item>
                <strong>School Enrollments:</strong>
                <br />
                The education institution must confirm with ApplyBoard that the student is attending
                classes for the intake they were enrolled in, and the school will therefore release
                commissions for that student.
              </List.Item>
              <List.Item>
                <strong>GICs:</strong>
                <br /> A certificate of investment must be issued by the bank.
              </List.Item>
              <List.Item>
                <strong>Education Loans:</strong>
                <br />
                First disbursement of funds from the loan provider must occur.
              </List.Item>
            </List>
          </Text>
        </Flex>
      ),
    },
  ];

  return (
    <Accordion
      allowMultipleOpen={false}
      onChange={function trackFaqOpen(value) {
        if (value)
          trackEvent({
            event: 'VAS - Rewards Landing Page - FAQ Question: Opened',
            data: {
              rp_id: rpId,
              source: source,
              faq_question: QUESTIONS_AND_ANSWERS[Number(value)].question,
            },
          });
      }}
    >
      {QUESTIONS_AND_ANSWERS.map((item, index) => (
        <Accordion.Item
          key={index}
          id={String(index)}
          title={
            <Flex pt={4} pb={4}>
              {item.question}
            </Flex>
          }
        >
          {item.answer}
        </Accordion.Item>
      ))}
    </Accordion>
  );
};
export default FaqAccordion;
